export default __webpack_public_path__ + "static/media/lato-italic.bf05ac17.woff";